module.exports = __webpack_public_path__ + "static/media/Ma.e62002fc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row2/Ma.mp3
// module id = 47
// module chunks = 0